import * as React from 'react';
import { RenderElementProps } from 'slate-react';
import { observer } from 'mobx-react-lite';
import styled from 'styled-components';

import { ELEMENT_PARAGRAPH } from '@doltech/utils/lib/constants';
import { isEmptySlateNodeValue } from '@doltech/utils/lib/editor';

import { useRootElement } from '../../../slatePlugins/common/hocs/current-element.store';
import { findBellowByType } from '../../../figma/DolEditor/helpers/nodeValue';
import { ResponsiveTypography } from '../../../figma/Typography/v3/ResponsiveTypography';
import { EXPLANATION } from '../types';

const Container = styled.div``;

export const GapFillExplanation = observer((props: RenderElementProps) => {
  const { children, element, attributes } = props;
  const rootElement = useRootElement();

  const textNode = findBellowByType(element, ELEMENT_PARAGRAPH);
  const explanations = findBellowByType(rootElement, EXPLANATION);

  const explanationIndex = explanations.findIndex((eachExplanation) => eachExplanation.id === element.id);
  const explanationOrder = explanationIndex + (rootElement?.startFrom || 1);

  if (isEmptySlateNodeValue(textNode)) {
    return null;
  }

  return (
    <Container
      className="gap-fill-explanation"
      contentEditable={false}
      {...attributes}
    >
      <ResponsiveTypography.Paragraph variant="medium/14-20" color="neutral180" mb="8px">
        Giải thích câu {explanationOrder}
      </ResponsiveTypography.Paragraph>
      {children}
    </Container>
  );
});
